import "@/App.css";
import { HashRouter, Routes, Route } from "react-router-dom";
import { Navigation } from "./components/Navigation";
import { HeroSection } from "./components/HeroSection";
import { EventsSection } from "./components/EventsSection";
import { PricingSection } from "./components/PricingSection";
import { FAQSection } from "./components/FAQSection";
import { ContactSection } from "./components/ContactSection";
import { Footer } from "./components/Footer";
import { CookieBanner } from "./components/CookieBanner";
import { Impressum } from "./pages/Impressum";
import { Datenschutz } from "./pages/Datenschutz";

const HomePage = () => {
  return (
    <div>
      <Navigation />
      <HeroSection />
      <EventsSection />
      <PricingSection />
      <FAQSection />
      <ContactSection />
      <Footer />
      <CookieBanner />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <HashRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
        </Routes>
      </HashRouter>
    </div>
  );
}

export default App;
